<template>
    <div class="login-container" style="background-color: #ffffff;margin: 0px;overflow: hidden;float: right">
        <div style="width: 100%;height: 50px;">
            <div class="login-button">
                <div class="login_first_cont_one">
                    <div :style="pwdTitleStyle" style="float: left;">
                        <span class="login_text">密码登录</span>
                    </div>
                </div>
                <div class="login_first_cont_one">
                    <div :style="valTitleStyle" id="valcode_div"><a
                            id="valcode_a" style="cursor: pointer;"><span
                            class="login_text">短信登录</span></a>
                    </div>
                </div>
            </div>
        </div>
        <Form id="loginForm" ref="loginForm" autoComplete="on" :model="loginForm" :rules="loginRules" class="card-box login-form" style="margin-top: 50px;">
            <Form-item prop="email" class="twice_pwd_login">
                <Input type="text" v-model="loginForm.email" placeholder="请输入用户名" autoComplete="on" class="username">
                </Input>
            </Form-item>
            <Form-item prop="password" class="twice_pwd_login" style="margin-top: 25px;">
                <Input type="password" v-model="loginForm.password" placeholder="请输入密码"
                       @keyup.enter.native="handleLogin">
                </Input>
            </Form-item>
            <Form-item style="margin-top: 50px;padding-left: 35px;" lass="twice_pwd_login" @click="handleLogin('loginForm')">
               <!-- <div class="submit" id="pwd_login">
                    <span class="dl_text">登录</span>
                </div>-->
                <Button type="primary" @click="handleLogin('loginForm')" long
                        style="width: 280px;height: 35px;background-color: #ffb319;border: 1px solid #ffb319">
                    <span style="font-size: 14px;letter-spacing: 2px;">登录</span>
                </Button>
            </Form-item>
        </Form>
    </div>
  <!--  <div>
        <div id="login" style="background-color: white;width: 350px;height: 350px;float: right">
            <div class="login_first">
                <div class="login_first_cont">
                    <div class="login_first_cont_one">
                        <div :style="pwdTitleStyle"
                             id="password_div"><a id="password_a" style="cursor: pointer;"><span
                                class="login_text">密码登录</span></a></div>
                    </div>
                    <div class="login_first_cont_one">
                        <div :style="valTitleStyle" id="valcode_div"><a
                                id="valcode_a" style="cursor: pointer;"><span
                                class="login_text">短信登录</span></a>
                        </div>
                    </div>
                </div>
            </div>
            <div id="twice_pwd_login" class="twice_pwd_login">
                <div class="input_div" style="padding-top: 50px;padding-left: 35px" :style="pwdLoginStyle">
                    <div class="user_div">
                        <input type="text" id="username_pwd" placeholder="用户名" />
                    </div>
                    <div class="pwd_div">
                        <input type="password" id="password_pwd" placeholder="密码" />
                    </div>
                    <div class="alert_div">
                        <a class="alert_a"><span>忘记密码</span></a><a class="reg_a"
                                                                   id="reg_a"><span>注册</span></a>
                    </div>
                    <div class="submit" id="pwd_login">
                        <span class="dl_text">登录</span>
                    </div>
                </div>
            </div>
            <div id="twice_val_login" class="twice_val_login" :style="valLoginStyle">
                <div class="input_div">
                    <div class="user_div">
                        <input type="text" id="phone" placeholder="手机号"/>
                    </div>
                    <div class="pwd_div">
                        <input type="text" id="valCode" class="valCode"
                               placeholder="验证码"/>
                        <div class="send_code">
                            <span id="send_val" class="val_text">发送验证码</span>
                        </div>
                    </div>
                    <div class="alert_div">
                        <a class="reg_a"><span>注册</span></a>
                    </div>
                    <div class="submit">
                        <a class="dl_text"><span>登录</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
</template>

<script>
    import {isWscnEmail} from 'utils/validate';
    import {addConcernCompany} from 'api/enuser';

    export default {
        name: 'login',
        props: {
            id: [String],
            name: [String]
        },
        data() {
            const validateEmail = (rule, value, callback) => {
                if (value == null || value.length == 0) {
                    callback(new Error('用户名不能为空'));
                } else {
                    callback();
                }
            };
            const validatePass = (rule, value, callback) => {
                if (value.length < 6) {
                    callback(new Error('密码不能小于6位'));
                } else {
                    callback();
                }
            };
            return {
                loginForm: {
                    email: '',
                    password: ''
                },
                loginRules: {
                    email: [
                        {required: true, trigger: 'blur', validator: validateEmail}
                    ],
                    password: [
                        {required: true, trigger: 'blur', validator: validatePass}
                    ]
                },
                loading: false,
                showDialog: false,
                pwdLoginStyle:{display : "block"},
                valLoginStyle:{display : "none"},
                pwdTitleStyle:{
                    width: "61px",
                    height: "50px",
                    paddingTop : "12px",
                    borderBottom : "3px solid #ffb319"
                },
                valTitleStyle:{
                    width: "61px",
                    height: "50px",
                    paddingTop : "12px",
                }
            }
        },
        mounted() {
        },
        methods: {
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$store.dispatch('LoginByEmail', this.loginForm).then(() => {
                            this.$Message.success('登录成功');
                            let obj = {};
                            if(this.id != null && this.name != null){
                                obj.companyId = this.id;
                                obj.companyName = this.name;
                                let array = [];
                                array.push(obj);
                                let param = {};
                                param.companyArray = array;
                                addConcernCompany(param).then(response => {
                                }).catch(err => {
                                });
                            }
                            this.loading = false;
                            this.$store.dispatch('setFirstFlag', 1).then(() => {
                            }).catch(err => {
                                this.$message.error(err);
                            });
                            this.$router.push({path: '/'});
                        }).catch(err => {
                            this.$message.error(err);
                            this.loading = false;
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }

    var SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;

    var container;
    var camera, scene, renderer;

    var particles, particle, count = 0;

    var mouseX = 0, mouseY = 0;

    var windowHalfX = 200;
    var windowHalfY = 400;


    // animate();

    function init() {


    }

    function onWindowResize() {

        windowHalfX = 500;
        windowHalfY = 400;

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(window.innerWidth, window.innerHeight);

    }

    //

    function onDocumentMouseMove(event) {

        mouseX = event.clientX - windowHalfX;
        mouseY = event.clientY - windowHalfY;

    }

    function onDocumentTouchStart(event) {

        if (event.touches.length === 1) {

            event.preventDefault();

            mouseX = event.touches[0].pageX - windowHalfX;
            mouseY = event.touches[0].pageY - windowHalfY;

        }

    }

    function onDocumentTouchMove(event) {

        if (event.touches.length === 1) {

            event.preventDefault();

            mouseX = event.touches[0].pageX - windowHalfX;
            mouseY = event.touches[0].pageY - windowHalfY;

        }

    }

    //

    function animate() {

        requestAnimationFrame(animate);

        render();


    }

    function render() {

        camera.position.x += (mouseX - camera.position.x) * .05;
        camera.position.y += (-mouseY - camera.position.y) * .05;
        camera.lookAt(scene.position);

        var i = 0;

        for (var ix = 0; ix < AMOUNTX; ix++) {

            for (var iy = 0; iy < AMOUNTY; iy++) {

                particle = particles[i++];
                particle.position.y = (Math.sin((ix + count) * 0.3) * 50) + (Math.sin((iy + count) * 0.5) * 50);
                particle.scale.x = particle.scale.y = (Math.sin((ix + count) * 0.3) + 1) * 2 + (Math.sin((iy + count) * 0.5) + 1) * 2;

            }

        }

        renderer.render(scene, camera);

        count += 0.1;

    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .login-container {
        height: 360px;
        width: 350px;
        background-color: #2d3a4b;
    }
    .login_text{
        display: inline-block;
        font-family: MicrosoftYaHei, sans-serif;
        color: #333333;
        font-size: 15px;
    }
    .login-button{
        width: 280px;
        height: 50px;
        border-bottom: 1px solid #e0e0e0;
        margin-left: 35px;
        padding-left: 25px;
    }
    .login_first_cont_one{
        width: 125px;
        height: 50px;
        float: left;
        padding-left: 32px;
    }
    .twice_pwd_login{
        width: 350px;
        padding-left: 35px;
    }
    .ivu-input{
        height: 36px;
        line-height: 34px;
        padding: 0 15px;
        font-size: 14px;
        width: 280px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        background-color: #fff;
        color: #202020;
    }
    .submit{
        height: 35px;
        background-color: #ffb319;
        width:280px;
        border-radius: 4px;
    }
    .dl_text{
        font-family: MicrosoftYaHe;
        cursor: pointer;
        display: inline-block;
        padding-left: 126px;
        padding-top: 6px;
        font-size: 14px;
        color: #ffffff;
    }
   /* .login_first{
        width: 350px;
        height: 50px;
        padding-left: 35px;
    }
    .login_first_cont{
        width: 280px;
        height: 50px;
        border-bottom: 1px solid #e0e0e0;
        padding-left: 50px;
    }
    .login_first_cont_one{
        width: 115px;
        height: 50px;
        float: left;
    }
    .twice_pwd_login{
        width: 350px;
        height: 250px;
    }
    .submit{
        height: 35px;
        background-color: #ffb319;
        width:280px;
        border-radius: 4px;
    }
    .twice_val_login{
        width: 350px;
        height: 250px;
    }
    .tips {
        font-size: 14px;
        color: #fff;
        margin-bottom: 5px;
    }
    .login-container {
        height: 380px;
        background-color: #2d3a4b;

        .login-button {
            height: 80px;
            font-size: 18px;
            letter-spacing: 2px;
            color: #333333;
            text-align: center;
            padding: 15px 181px;
        }

        input:-webkit-autofill {
            -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
            -webkit-text-fill-color: #fff !important;
        }

        input {
            width: 339px;
            height: 50px;
            background-color: #f5f5f5;
            border-radius: 3px;
            border: solid 1px #dddddd;
            -webkit-appearance: none;
            padding: 12px 5px 12px 15px;
            color: #000;
            font-size: 14px;
        }

        input:focus {
            background: transparent;
        }

        .el-input {
            display: inline-block;
            height: 47px;
            width: 85%;
        }

        .svg-container {
            padding: 6px 5px 6px 15px;
            color: #889aa4;
        }

        .title {
            font-size: 26px;
            font-weight: 400;
            color: #eeeeee;
            margin: 0px auto 40px auto;
            text-align: center;
            font-weight: bold;
        }

        .login-form {
            position: absolute;
            left: 0;
            right: 0;
            width: 400px;
            padding: 0px 35px 15px 35px;
            margin: 0 auto;
        }

        .el-form-item {
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            color: #454545;
        }

        .forget-pwd {
            color: #fff;
        }
    }
    .login_text{
        display: inline-block;
        font-family: "Microsoft YaHei", sans-serif;
        color: #333333;
        font-size: 15px;
        !*   padding-top: 20px;
           padding-left: 35px;*!
    }
    .user_div{
        width: 280px;
        height: 60px;
    }
    .pwd_div{
        width: 280px;
        height: 50px;
    }
    .alert_div{
        width: 280px;
        height: 40px;
    }
    .alert_a{
        font-size: 12px;
        color: #999999;
        float: left;
        cursor: pointer;
    }
    .reg_a{
        font-size: 12px;
        color: #999999;
        float: right;
        cursor: pointer;
    }
    Input{
        height: 36px;
        line-height: 34px;
        padding: 0 15px;
        font-size: 14px;
        width: 280px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        background-color: #fff;
        color: #202020;
    }
    .dl_text{
        font-family: MicrosoftYaHe;
        cursor: pointer;
        display: inline-block;
        padding-left: 126px;
        padding-top: 6px;
        font-size: 14px;
        color: #ffffff;
    }*/
</style>



// WEBPACK FOOTER //
// index.vue?3a6dabd1